import { FunctionalComponent } from 'preact'
/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import Dropdown from '@insided/deprecated-preact-components/dropdown'
import UserAvatar, { User } from '@insided/deprecated-preact-components/User/UserAvatar'
/* eslint-enable import/no-internal-modules */

export interface UserAvatarDropdownProps {
  user: User
}

const UserAvatarDropdown: FunctionalComponent<UserAvatarDropdownProps> = ({ user }) => {
  return (
    <div className='control-side-menu__menu-item-avatar'>
      <Dropdown popupName='control-sidebar__menu-user' trigger={<UserAvatar user={user} disableLink />}>
        <div className='control-side-menu__menu-user'>
          <a href='/member/logout'>
            <Icon icon='logOut' />
            Log out
          </a>
        </div>
      </Dropdown>
    </div>
  )
}

export default UserAvatarDropdown
